import { IInteractiveItem } from "@cayo/shared/components/Alerts/types";

export const ALERTS_PANE_MAX_ITEMS = 100;
export interface INotificationMessage {
  action: NotificationAction;
  body: string;
  source: string;
}
export enum NotificationAction {
  Add,
  Remove,
  Modify,
  Notify,
  Replace,
  RemoveAll,
}
export interface IUpdateInteractiveItemAction {
  action?: NotificationAction | undefined;
  maxItems?: number | undefined;
  newItems?: IInteractiveItem[] | null;
  noSort?: boolean;
  addNewToTail?: boolean;
}

export interface INotificationSubscription {
  handler: (messages: INotificationMessage[]) => void;
  source: string;
}
